/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `SsoEmailDomain.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { SsoEmailDomain } from "./SsoEmailDomain";

import { Team } from "./Team";

export abstract class SsoEmailDomainModel {
    id: number;
    createdAt: Dayjs;
    emailDomain: string;
    teamId: number;
    updatedAt: Dayjs;
    team: Team | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        createdAt: Dayjs,
        emailDomain: string,
        teamId: number,
        updatedAt: Dayjs,
        team: Team | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.emailDomain = emailDomain;
        this.teamId = teamId;
        this.updatedAt = updatedAt;
        this.team = team;
    }

    static fromApiObject(json: any, timezone: string): SsoEmailDomain {
        const newObject = new SsoEmailDomain(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["email_domain"],
            json["team_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["team"] == null ? json["team"] : Team.fromApiObject(json["team"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            email_domain: this.emailDomain,
            team_id: this.teamId,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): SsoEmailDomain {
        const clone = Object.create(this) as SsoEmailDomain;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
